import {NgModule} from '@angular/core';
import {WebLessonNotificationComponent} from "./web-lesson-notification.component";
import {CommonModule} from "@angular/common";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
	imports: [
		CommonModule,
		FontAwesomeModule
	],
	exports: [
		WebLessonNotificationComponent,
	],
	declarations: [
		WebLessonNotificationComponent,
	],
	providers: [],
})
export class WebLessonNotificationModule {
}
